import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { ICON_SPRITE_PATH } from '../../../config/paths';

const propTypes = {
  blockName: PropTypes.string,
  id: PropTypes.string.isRequired,
};

const defaultProps = {
  blockName: null,
};

function Icon(props) {
  const svgClasses = classNames(props.blockName, 'Icon');

  return (
    <svg className={svgClasses} aria-hidden="true">
      <use xlinkHref={`${ICON_SPRITE_PATH}#icon-${props.id}`} />
    </svg>
  );
}

Icon.propTypes = propTypes;
Icon.defaultProps = defaultProps;

export default Icon;
